import ClientModule from "@gqlapp/module-client-react";
import Route from "@lib/Route";
import List from "@modules/video/components/list";
import {defaultRoute, getProps} from "@modules/video/helpers/config";

export default new ClientModule({
	route:{ TaxonomyClip: <Route {...getProps(defaultRoute, List, { classNameOnPage: 'taxonomy taxonomy-clip' })} /> }
});
